import instance from "./axiosInstance";

async function call(method, url, data, params) {
  const response = await instance({
    method,
    url: `/ota${url}`,
    data,
    params,
    timeout: 70000,
    headers: {
      "Content-Type":
        data instanceof FormData ? "multipart/form-data" : "application/json",
    },
  });
  if (response.data.code !== 0)
    throw new Error(response.data.message || "OTA操作失败");
  return response.data.data;
}
const idPath = (id) => encodeURIComponent(id);
export const otaSettings = () => call("get", "/settings");
export const otaReleases = () => call("get", "/releases");
export const otaUpload = (form) => call("post", "/releases", form);
export const otaManifest = (id) =>
  call("get", `/releases/${idPath(id)}/manifest`);
export const otaReleaseAction = (id, action) =>
  call("post", `/releases/${idPath(id)}/${action}`);
export const otaDevices = (params) => call("get", "/devices", null, params);
export const otaReadiness = (id, data) =>
  call("put", `/devices/${idPath(id)}/readiness`, data);
export const otaEvents = (id) => call("get", `/devices/${idPath(id)}/events`);
export const otaDeployments = () => call("get", "/deployments");
export const otaDeployment = (id) => call("get", `/deployments/${idPath(id)}`);
export const otaCreateDeployment = (data) => call("post", "/deployments", data);
export const otaDeploymentAction = (id, action) =>
  call("post", `/deployments/${idPath(id)}/${action}`);
export const otaAudit = () => call("get", "/audit");
